module.exports = __webpack_public_path__ + "img/jdyd.ea231fe9.png";